/* eslint-disable no-shadow */
/* eslint-disable */
import React, { Component } from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import MenueItems from './MenueItems';
import BusinessMobileSidebar from './BusinessMobileSidebar';
import { Div } from './style';
// import HeaderSearch from '../components/header-search/header-search';
// import AuthInfo from '../components/utilities/auth-info/info';
import '../static/css/style.css';

import logo from '../assets/images/logo.png';
import { destroySession } from '../helpers/functions';
import { connectStripeAccount } from '../redux/businessAccount/stripeAction';
import { connectAccountStatus } from '../redux/businessAccount/detailsAction';

import { darkTheme } from '../config/theme/themeVariables';

const { Header, Footer, Sider, Content } = Layout;
// const { darkMode } = config;

const ThemeLayout = (WrappedComponent) => {
    class LayoutComponent extends Component {
        constructor(props) {
            super(props);
            this.state = {
                collapsed: false,
                hide: true,
                searchHide: true,
                activeSearch: false,
                connectLoading: false,
                bannerHeight: 0,
            };
            this.updateDimensions = this.updateDimensions.bind(this);
            this.handleRedirect = this.handleRedirect.bind(this);
            this.handleStripeConnect = this.handleStripeConnect.bind(this);
        }

        componentDidMount() {
            window.addEventListener('resize', this.updateDimensions);
            this.updateDimensions();

            const { userData, accountStatus, dispatch } = this.props;
            if (userData?.stripe_connect_id && !accountStatus) {
                dispatch(connectAccountStatus(userData.stripe_connect_id));
            }
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.updateDimensions);
        }

        updateDimensions() {
            const banner = document.getElementById('stripe-banner');
            this.setState({
                collapsed: window.innerWidth <= 1150 && true,
                bannerHeight: banner ? banner.offsetHeight : 0,
            });
        }

        componentDidUpdate(prevProps) {
            if (
                prevProps.userData?.stripe_connect_charges_enabled !==
                this.props.userData?.stripe_connect_charges_enabled
            ) {
                // Use setTimeout to ensure the DOM has updated and the banner is rendered
                setTimeout(this.updateDimensions, 0);
            }

            if (this.props.userData?.stripe_connect_id && !this.props.accountStatus && prevProps.userData?.stripe_connect_id !== this.props.userData?.stripe_connect_id) {
                this.props.dispatch(connectAccountStatus(this.props.userData.stripe_connect_id));
            }
        }

        handleRedirect() {
            const { history } = this.props;
            destroySession();
            history.push('/login');
        }

        handleStripeConnect = async () => {
            const { dispatch } = this.props;
            await dispatch(
                connectStripeAccount((loading) =>
                    this.setState({ connectLoading: loading })
                )
            );
        };

        render() {
            const {
                collapsed,
                hide,
                searchHide,
                activeSearch,
                connectLoading,
                bannerHeight,
            } = this.state;
            const {
                ChangeLayoutMode,
                rtl,
                topMenu,
                hasSubscription,
                userData,
            } = this.props;

            const left = !rtl ? 'left' : 'right';
            const darkMode = ChangeLayoutMode;

            const isStripeConnected =
                userData?.stripe_connect_charges_enabled === true;

            const { accountStatus } = this.props;
            const isStripeIncomplete =
                !isStripeConnected &&
                accountStatus &&
                (accountStatus.status === 'restricted' ||
                 (accountStatus.requirements && accountStatus.requirements.length > 0));

            const toggleCollapsedMobile = () => {
                if (window.innerWidth <= 990) {
                    this.setState({
                        collapsed: !collapsed,
                    });
                }
            };

            const SideBarStyle = {
                margin: '0',
                padding: `${41 + (!isStripeConnected ? bannerHeight : 0)}px 0px 55px`,
                overflowY: 'auto',
                height: '100vh',
                position: 'fixed',
                top: 0,
                [left]: 0,
                zIndex: 998,
                background: '#2b5c35',
            };

            return (
                <Div darkMode={darkMode}>
                    {!isStripeConnected && (
                        <div
                            id="stripe-banner"
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 1001,
                                backgroundColor: '#397a47',
                                padding: '12px 20px',
                                textAlign: 'center',
                                color: '#fff',
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '15px',
                            }}
                        >
                            <span style={{ fontSize: '14px', fontWeight: 500 }}>
                                {isStripeIncomplete
                                    ? 'Your Stripe account setup is incomplete. Your business is not live and will not appear in customer search results until you finish setting it up to receive payouts.'
                                    : 'Connect your Stripe account. Your business is not live and will not appear in customer search results until your account is connected.'}
                            </span>
                            <button
                                onClick={this.handleStripeConnect}
                                disabled={connectLoading}
                                style={{
                                    padding: '6px 12px',
                                    backgroundColor: '#fff',
                                    color: '#2b5c35',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {connectLoading
                                    ? 'Processing...'
                                    : isStripeIncomplete
                                        ? 'Resume Setup'
                                        : 'Connect Account'}
                            </button>
                        </div>
                    )}
                    <Layout className="layout">
                        <Header
                            className={`bg-transparent box-shadow-0 d-top-header h-76 align-items-center justify-content-between`}
                        >
                            <div className="col-auto px-0 navbar-brand">
                                <Link to="/home">
                                    <img
                                        src={logo}
                                        className={`img-fluid`}
                                        style={{
                                            width: '150px',
                                            height: 'auto',
                                        }}
                                        alt="Logo"
                                    />
                                </Link>
                            </div>

                            <div className="col-auto px-0 navbar-brand">
                                {!topMenu || window.innerWidth <= 1150 ? (
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 border-0 business-sidebar-toggle"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#businessMobileSidebar"
                                        aria-controls="businessMobileSidebar"
                                        aria-label="Open menu"
                                    >
                                        <img
                                            src={require(`../static/img/icon/${
                                                collapsed
                                                    ? 'left.svg'
                                                    : 'right.svg'
                                            }`)}
                                            alt="menu"
                                        />
                                    </button>
                                ) : null}
                            </div>
                        </Header>

                        {/* <div className="header-more">
                            <Row>
                                <Col md={0} sm={24} xs={24}>
                                    <div className="small-screen-headerRight">
                                        <SmallScreenSearch
                                            hide={searchHide}
                                            darkMode={darkMode}
                                        >
                                            <HeaderSearch rtl={rtl} />
                                        </SmallScreenSearch>
                                        <SmallScreenAuthInfo
                                            hide={hide}
                                            darkMode={darkMode}
                                        >
                                            <AuthInfo rtl={rtl} />
                                        </SmallScreenAuthInfo>
                                    </div>
                                </Col>
                            </Row>
                        </div> */}
                        <Layout>
                            <ThemeProvider theme={darkTheme}>
                                <Sider
                                    width={220}
                                    style={SideBarStyle}
                                    collapsed={collapsed}
                                    theme={'dark'}
                                    className={`ant-layout-rtl sidebar-scroll`}
                                >
                                    {/* <Scrollbars
                                        className="custom-scrollbar"
                                        autoHide
                                        autoHideTimeout={500}
                                        autoHideDuration={200}
                                        renderThumbHorizontal={
                                            renderThumbHorizontal
                                        }
                                        renderThumbVertical={
                                            renderThumbVertical
                                        }
                                        renderView={renderView}
                                        renderTrackVertical={
                                            renderTrackVertical
                                        }
                                    > */}
                                    <div className={`text-center mb-35`}>
                                        <Link to="/home">
                                            <img
                                                src={logo}
                                                className={`img-fluid`}
                                                style={{
                                                    width: '150px',
                                                    height: 'auto',
                                                }}
                                                alt="Logo"
                                            />
                                        </Link>
                                    </div>
                                    <MenueItems
                                        topMenu={topMenu}
                                        rtl={rtl}
                                        toggleCollapsed={toggleCollapsedMobile}
                                        darkMode={darkMode}
                                    />

                                    {/* </Scrollbars> */}
                                </Sider>
                            </ThemeProvider>

                            <Layout className="atbd-main-layout mt-0">
                                <Content>
                                    <WrappedComponent {...this.props} />
                                </Content>
                            </Layout>
                        </Layout>
                    </Layout>

                    <BusinessMobileSidebar />
                </Div>
            );
        }
    }

    const mapStateToProps = (state) => {
        const subscriptionStatus = state?.businessDetails?.subscriptionStatus;
        return {
            ChangeLayoutMode: state.ChangeLayoutMode.data,
            rtl: state.ChangeLayoutMode.rtlData,
            topMenu: state.ChangeLayoutMode.topMenu,
            hasSubscription: Boolean(subscriptionStatus?.hasSubscription),
            userData: state.user?.userData,
            accountStatus: state.businessDetails?.accountStatus,
        };
    };

    LayoutComponent.propTypes = {
        ChangeLayoutMode: propTypes.bool,
        rtl: propTypes.bool,
        topMenu: propTypes.bool,
        changeRtl: propTypes.func,
        changeLayout: propTypes.func,
        changeMenuMode: propTypes.func,
    };

    return connect(mapStateToProps)(LayoutComponent);
};
export default ThemeLayout;
